export const empty = el => {
  while (el.firstChild) {
    el.removeChild(el.firstChild)
  }
}
